var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListCard',{staticClass:"sticky",attrs:{"title":_vm.group,"selected":_vm.selected}},[_c('div',{staticClass:"size",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"field-count"},[_vm._v(_vm._s(_vm.fieldCount))])])])}
var staticRenderFns = []

export { render, staticRenderFns }